var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02074 8.98483L1.0872 5.90461C0.793849 5.56237 0.793849 5.07345 1.0872 4.7312C1.38056 4.43785 1.86948 4.43785 2.21173 4.7312L4.60745 7.2736L11.2079 0.67314C11.5013 0.379787 11.9902 0.379787 12.2835 0.67314C12.5769 1.01539 12.5769 1.50431 12.2835 1.84656L5.14526 8.98483C4.85191 9.32708 4.36299 9.32708 4.02074 8.98483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSelect);
export default __webpack_public_path__ + "static/media/tickSelect.3ab505dde84f4b410f718f43b57c60f0.svg";
export { ForwardRef as ReactComponent };